import type React from 'react';
import { StatusDot } from '@/components/data-display/StatusDot';
import './Toast.scss';

export interface ToastProps {
  message: string;
  tone?: 'success' | 'warning' | 'danger';
}

export const Toast: React.FC<ToastProps> = ({ message, tone = 'success' }) => (
  <div className="toast" role="status" aria-live="polite">
    <StatusDot tone={tone === 'success' ? 'live' : tone} />
    {message}
  </div>
);

export default Toast;
